import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase.js';

import { PAGINATION, FILTER } from '../../../common/types/paginationType.js';
import global from '../../../common/utility/global.js';

import cuentaCobradaService from '../../../service/creditoCobranza/CuentaCobradaService.js';
import metodoPagoService from '../../../service/administracion/metodoPagoService.js';

import cuentaService from '../../../service/administracion/cuentaService.js';
import Header from "../../../components/Header.js";
import Filters from './Filters.js';
import ResultList from './ResultList.js';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingImprimir: false,
            loadingPrint: false,
            loadingVer: false,
            listaEstadoPago: [],
            metodoPagos: [],
            cuentas: [],
            listaTipoComprobante: [],
            filter: {
                idTipoComprobante: 0,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                cliente: '',
                idMetodoPago: 0,
                idCuenta: 0,
                documento: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false
        }
    }

    /********* PAGINATION ********/
    handleClearFilters = () => {
        var filter = {
            idTipoComprobante: 0,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: '',
            cliente: '',
            idMetodoPago: 0,
            idCuenta: 0,
            documento: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        debugger
        e.preventDefault();
        if (e.keyCode === 13) {
            this.ChangePaginationGetData();
        }
    };

    handleChange = async (property, value, texto, param) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter: filter });
    };


    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await cuentaCobradaService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cuentas Cobradas.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cuentaCobradaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cuentas Cobradas.pdf");
    }



    /******************** FORM MODAL *****************/


    async componentDidMount() {

        const metodoPagos = await metodoPagoService.listar();
        const cuentaDestino = await cuentaService.listar_select();

        this._initPagination({ ...this.state.filter }, cuentaCobradaService.paginacion);


        this.setState({
            loadingSource: false,
            metodoPagos: metodoPagos ? metodoPagos : [],
            cuentas: cuentaDestino ? cuentaDestino : [],
            listaEstadoPago: [],
            listaTipoComprobante: [{ 'id': 2, 'nombre': 'FACTURA' }, { 'id': 4, 'nombre': 'BOLETA' }, { 'id': 97, 'nombre': 'NOTA VENTA' }]

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte de Cuentas Cobradas"
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estado={this.state.listaEstadoPago}
                    metodoPagos={this.state.metodoPagos}
                    cuentas={this.state.cuentas}
                    listaTipoComprobante={this.state.listaTipoComprobante}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />

                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onChange={this._handleChangePagination}

                />
            </div>
        );
    };
}